import React, { Component, Fragment } from "react";
import "./style.scss";
import { connect } from "react-redux";
import { addNewsAdmin, listCompany, getDetailNew, updateNews, deleteNewsAdmin, ACTIONS } from './../../../../actions/admin-news';
import Loading from './../../../../components/loading/index';
import queryString from 'query-string';
import moment from 'moment';
import {toast} from 'react-toastify';

class OptionAdminNews extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDropdown: false,
            information: '',
            time: '2019-05-04',
            hour: 12,
            minute: 34,
            company: [],
            show: false,
            listsCompany: [],
            listsCompanyCopy: [],
            isShowListsCompany: false,
            idDeleteCompany: null,
            showLoading: true,
            isEditTime: true
        }
    }

    UNSAFE_componentWillMount() {
        const params = queryString.parse(this.props.location.search)
        this.props.listCompany();
        if (params.id) {
            this.props.getDetailNew(params.id);
        }
        this.handleTime();
    }

    handleTime() {
        const time = moment(new Date()).format('YYYY/MM/DD').split('/').join('-');
        const hour = moment(new Date()).format('HH').split('/').join('-');
        const minute = moment(new Date()).format('mm').split('/').join('-');
        this.setState({
            time,
            hour,
            minute
        });
    }

    onChange = (ev) => {
        ev ? this.setState({ showDropdown: true }) : this.setState({ showDropdown: false });
    }

    clickItemDropdown(e) {
    }

    onChangeDataInput = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        this.setState({
            [name]: value
        });
    }

    submitForm = () => {
        this.setState({ showLoading: true });
        const params = queryString.parse(this.props.location.search)
        let { information, time, hour, minute, company } = this.state;

        const body = {
            content: information,
            time: `${time} ${hour}:${minute}:00`,
            companies: company
        };
        if (params.id) {
            this.props.updateNews(body, params.id);
        } else {
            this.props.addNewsAdmin(body);
        }
    }

    deleteNotification(e) {
        e.preventDefault();

        const wrapNewsDelete = document.getElementById('wrap-news-deletes');
        wrapNewsDelete.style.display = 'flex';
    }

    hideDeleteNews = (i) => {
        const wrapNewsDelete = document.getElementById('wrap-news-deletes');
        wrapNewsDelete.style.display = 'none';
        if (i) {
            const params = queryString.parse(this.props.location.search);
            this.props.deleteNewsAdmin(params.id);
            this.setState({ showLoading: true })
        }
    }

    componentDidUpdate() {
        this.commonHideComponent('wrap-news-deletes', 'news-deletes');
    }

    commonHideComponent(p, c) {
        let wrapWorkspace = document.getElementById(p);
        let workspace = document.getElementById(c);
        if (wrapWorkspace && workspace) {
            wrapWorkspace.addEventListener('click', function (event) {
                const isClickInside = workspace.contains(event.target);
                if (!isClickInside) {
                    wrapWorkspace.style.display = 'none';
                }
            });
        }
    }

    createLabelNews = (e) => {
        const input1 = document.getElementById('input-tag');
        if (e.key === 'Enter') {
            e.preventDefault();
            if (input1.value) {
                if (this.state.isShowListsCompany) {
                    const valueCompany = this.state.listsCompany[0].name;
                    this.selectLabelNews(valueCompany)
                    let listIdCompany = this.state.company;
                    listIdCompany.push(this.state.listsCompany[0].id)

                    this.setState({
                        isShowListsCompany: false,
                        company: listIdCompany
                    })
                }
            } else {
                return null;
            }
        }

        const listDeleteTag = document.getElementsByClassName('delete-tag');
        window.addEventListener('click', (evt) => {
            for (let i = 0; i <= listDeleteTag.length; i++) {
                if (evt.target === listDeleteTag[i]) {
                    listDeleteTag[i].parentNode.style.display = 'none';
                }
            }
        });
        this.setState({ show: false });
    }

    selectLabelNews = (val) => {
        const input1 = document.getElementById('input-tag');
        const content = document.getElementById('content-tag');
        const div1 = document.createElement('div');
        div1.setAttribute('class', 'div-wrap-tag');

        div1.setAttribute('id', 'item');
        div1.style.display = 'flex';
        div1.style.alignItems = 'center';
        const img1 = document.createElement('IMG');
        img1.setAttribute('class', 'delete-tag');
        img1.setAttribute('src', './../img/ic_remove_svg.svg');
        const span1 = document.createElement('span');
        span1.style.marginRight = '8px';
        span1.style.whiteSpace = 'nowrap';
        span1.innerText = val;

        div1.appendChild(span1);
        div1.appendChild(img1);
        content.appendChild(div1);
        input1.value = '';

        const listDeleteTag = document.getElementsByClassName('delete-tag');

        window.addEventListener('click', (evt) => {
            for (let i = 0; i <= listDeleteTag.length; i++) {

                if (evt.target === listDeleteTag[i]) {
                    listDeleteTag[i].parentNode.remove();
                    let listIdCompany = this.state.company;
                    listIdCompany.splice(i, 1);
                    this.setState({
                        company: listIdCompany
                    })
                }

            }
        });


        this.setState({ show: false });
    }

    deleteLabel = (e) => {
        const input1 = document.getElementById('input-tag');
        const content = document.getElementById('content-tag');
        if (!input1.value) {
            if (e.key === 'Backspace' || e.key === 'Delete') {
                const list = document.getElementsByClassName('div-wrap-tag');
                if (list.length > 0) {
                    content.removeChild(list[list.length - 1]);
                    let listIdCompany = this.state.company;
                    listIdCompany.pop();
                    this.setState({
                        company: listIdCompany
                    })
                }
            }
        }

    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!nextProps) {
            return;
        }

        this.setState({
            listsCompany: nextProps.listsCompany,
            listsCompanyCopy: nextProps.listsCompany
        })

        if (nextProps.statusUpdate || nextProps.detailNews || nextProps.statusDelete || nextProps.statusAddNews || nextProps.listCompany) {
            this.setState({ showLoading: false })
        }
        if (nextProps.type === ACTIONS.GET_DETAIL_NEWS_SUCCESS) {
            let companies = [];

            //3k, refactor later
            const content = document.getElementById('content-tag');
            content.innerHTML = ''

            nextProps.detailNews.companies.forEach((val, i) => {
                companies.push(val.id);
                this.selectLabelNews(val.name)
            })

            const currentDate = moment(new Date()).format('YYYY/MM/DD HH:mm').split('/').join('-');
            const timeCurrent = moment(currentDate).unix();
            const timeOpen = moment(nextProps.detailNews.opened_at).unix();
            if (timeCurrent > timeOpen) {
                this.setState({
                    isEditTime: false
                })
            } else {
                this.setState({
                    isEditTime: true
                })
            }

            this.setState({
                information: nextProps.detailNews.content,
                company: companies,
                hour: nextProps.detailNews.opened_at.split(' ')[1].split(':')[0],
                minute: nextProps.detailNews.opened_at.split(' ')[1].split(':')[1],
                time: nextProps.detailNews.opened_at.split(' ')[0]
            })
        } else if (nextProps.type === ACTIONS.GET_COMPANY_SUCCESS) {
            this.setState({
                listsCompany: nextProps.listsCompany,
                listsCompanyCopy: nextProps.listsCompany
            })
        } else if (nextProps.type === ACTIONS.UPDATE_NEWS_SUCCESS || nextProps.type === ACTIONS.ADD_NEWS_SUCCESS || nextProps.type === ACTIONS.DELETE_NEWS_SUCCESS) {
            this.props.history.push({
                pathname: '/admin-news'
            })
        } else if (nextProps.type === ACTIONS.ADD_NEWS_ERROR) {
            nextProps.statusAdd.forEach(($v) => toast.error($v)) ;
        } else if (nextProps.type === ACTIONS.UPDATE_NEWS_ERROR) {
            nextProps.statusUpdate.forEach(($v) => toast.error($v)) ;
        }
        this.setState({ showLoading: false })

    }

    componentDidMount() {
        // this.props.listCompany();
    }

    findCompanySearch(e) {
        let arr = [];
        arr = this.state.listsCompanyCopy.filter((value, index) => {
            return value.name.toLowerCase().toLowerCase().includes(e.target.value);
        });

        this.setState({
            listsCompany: arr,
        });

        if (arr.length) {
            this.setState({
                isShowListsCompany: true
            });
        } else {
            this.setState({
                isShowListsCompany: false
            });
        }


    }

    selectCompanyInSearch(value) {
        this.selectLabelNews(value.name);

        let listIdCompany = this.state.company;
        listIdCompany.push(value.id)
        this.setState({
            isShowListsCompany: false,
            company: listIdCompany
        })
    }

    render() {
        let pathname = this.props.history.location.pathname;
        let searchAdd = pathname.search('/add')
        let isAdd = searchAdd > 0

        return (
            <Fragment>
                <div className="news">
                    <div className="block-title">
                        <img src="/img/navigation/arrow_back_24px.svg" alt="Arrow Icon" onClick={() => { this.props.history.goBack() }} />
                        <h2 className="block-title__text--main">{isAdd ? '新規お知らせの追加' : 'お知らせの編集'}</h2>
                    </div>

                    <form className="block-content" >
                        <section className="left">
                            <h4 className="title">お知らせ内容</h4>
                            <textarea
                                className="textarea"
                                name="information"
                                value={this.state.information}
                                onChange={this.onChangeDataInput}
                            ></textarea>
                        </section>
                        <section className="right">
                            <div className="right-top">
                                <h4 className="title">宛先指定</h4>
                                {/* input tag */}
                                <div>
                                    <div id="wrap-input-tag">
                                        <div id='content-tag'></div>
                                        <input type='text' id="input-tag" autoComplete="off" onChange={(e) => this.findCompanySearch(e)} onKeyDown={(e) => this.deleteLabel(e)} onKeyPress={(e) => this.createLabelNews(e)} />
                                    </div>
                                    {
                                        this.state.isShowListsCompany

                                            ? <ul id='list-company-search'>
                                                {
                                                    this.state.listsCompany.map((val, i) => {
                                                        return (
                                                            <li key={i} onClick={() => this.selectCompanyInSearch(val)}>
                                                                {val.name}
                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                            : null
                                    }
                                </div>

                            </div>
                            <div className="right-bottom">
                                <h4 className="title">公開設定</h4>
                                <h4 className="title no-border">公開日時</h4>
                                <div className="form-date">
                                    <input
                                        type="date"
                                        value={this.state.time}
                                        className="time-option"
                                        name="time"
                                        onChange={this.onChangeDataInput}
                                        disabled={!this.state.isEditTime}
                                    />
                                    <span>@</span>
                                    <input
                                        type="number"
                                        min="0"
                                        max="24"
                                        value={this.state.hour}
                                        className="hour-option"
                                        name="hour"
                                        onChange={this.onChangeDataInput}
                                        disabled={!this.state.isEditTime}
                                    />
                                    <input
                                        type="number"
                                        min='0'
                                        max="59"
                                        value={this.state.minute}
                                        className="minute-option"
                                        name="minute"
                                        onChange={this.onChangeDataInput}
                                        disabled={!this.state.isEditTime}
                                    />
                                </div>
                                <div className="block-button" style={(isAdd || !this.state.isEditTime) ? { justifyContent: 'flex-end' } : { justifyContent: 'space-between' }}>

                                    {
                                        (isAdd || !this.state.isEditTime)
                                            ? null
                                            : <button onClick={(e) => this.deleteNotification(e)}>お知らせを削除</button>
                                    }
                                    <button disabled={!this.state.information || !this.state.company.length} type="button" onClick={() => this.submitForm()}>{isAdd ? '公開する' : '変更する'}</button>

                                </div>
                            </div>
                        </section>
                    </form>
                </div>


                {/* delete news  */}
                <div className="wrap-news-deletes" id="wrap-news-deletes">
                    <div className="news-deletes" id="news-deletes">
                        <h4>お知らせの削除</h4>
                        <p>このお知らせを削除します。本当によろしいですか？</p>
                        <div>
                            <button onClick={() => this.hideDeleteNews(0)}>キャンセル</button>
                            <button onClick={() => this.hideDeleteNews(1)}>削除</button>
                        </div>
                    </div>
                </div>

                <Loading show={this.state.showLoading} />
            </Fragment>

        )
    }
}

const mapStateToProps = ({ adminNews }) => {
    return {
        listsCompany: adminNews.listCompany,
        status: adminNews.status,
        detailNews: adminNews.detailNews,
        statusAdd:  adminNews.statusAddNews,
        statusUpdate: adminNews.statusUpdate,
        statusDelete: adminNews.statusDelete,
        type: adminNews.type
    }
}

const mapDispatchToProps = dispatch => {
    return {
        addNewsAdmin: (body) => {
            dispatch(addNewsAdmin(body));
        },
        listCompany: () => {
            dispatch(listCompany());
        },
        getDetailNew: (id) => {
            dispatch(getDetailNew(id));
        },
        updateNews: (body, id) => {
            dispatch(updateNews(body, id));
        },
        deleteNewsAdmin: (id) => {
            dispatch(deleteNewsAdmin(id));
        }

    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(OptionAdminNews);
